/* global axios */
import ApiClient from './ApiClient';

class WhatsappCallsAPI extends ApiClient {
  constructor() {
    super('whatsapp_calls', { accountScoped: true });
  }

  show(callId) {
    return axios.get(`${this.url}/${callId}`).then(r => r.data);
  }

  eligibility(accountId, conversationId) {
    return axios
      .get(`/api/v1/accounts/${accountId}/conversations/${conversationId}/whatsapp_calls/eligibility`)
      .then(r => r.data);
  }

  requestPermission(accountId, conversationId) {
    return axios
      .post(`/api/v1/accounts/${accountId}/conversations/${conversationId}/whatsapp_calls/request_permission`)
      .then(r => r.data);
  }

  initiate({ accountId, conversationId, contactId, inboxId }, sdpOffer) {
    const url = accountId
      ? `/api/v1/accounts/${accountId}/whatsapp_calls/initiate`
      : `${this.url}/initiate`;
    return axios
      .post(url, {
        conversation_id: conversationId,
        contact_id: contactId,
        inbox_id: inboxId,
        sdp_offer: sdpOffer,
      })
      .then(r => r.data);
  }

  accept(accountId, callId, sdpAnswer) {
    return axios
      .post(`/api/v1/accounts/${accountId}/whatsapp_calls/${callId}/accept`, { sdp_answer: sdpAnswer })
      .then(r => r.data);
  }

  reject(accountId, callId) {
    return axios.post(`/api/v1/accounts/${accountId}/whatsapp_calls/${callId}/reject`).then(r => r.data);
  }

  terminate(accountId, callId) {
    return axios.post(`/api/v1/accounts/${accountId}/whatsapp_calls/${callId}/terminate`).then(r => r.data);
  }

  uploadRecording(accountId, callId, blob, filename) {
    const formData = new FormData();
    formData.append('recording', blob, filename);
    return axios
      .post(`/api/v1/accounts/${accountId}/whatsapp_calls/${callId}/upload_recording`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(r => r.data);
  }
}

export default new WhatsappCallsAPI();
